export function deslugify(slug: string, capitalize: boolean | undefined = false ) {
  let text = slug.replace(/[-_]+/g, " ");
  if (capitalize) {
    text = text.replace(/\b\w/g, char => char.toUpperCase());
  }

  return text;
}

function slugify(text: string) {
  return text
    .normalize('NFD').replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export default slugify;
